import { DialogService, GridAction } from '@eforall/dashboard';
import { ContactRequest } from '@interfaces';
import { BaseEngagementService } from '../../../../../services';
import { ContactRequestDialog, ContactRequestDialogData } from '../../../dialog';
import { PersonDialog } from '../../../person-dialog';

export function getActions(dialogService: DialogService, pageService: BaseEngagementService): GridAction<ContactRequest>[] {

	const actions: GridAction<ContactRequest>[] = [
		{
			iconClass: 'fa-regular fa-eye',
			label: 'View Request Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom<ContactRequestDialog, ContactRequestDialogData>(ContactRequestDialog, {
					data: {
						contactRequestId: rows[0]!.contactRequestId,
						personId: rows[0]!.person.id,
						staffRoleId: pageService.staffRoleId()!,
						externalRoleId: pageService.externalRoleId?.()
					}
				}, 600, 600);
				pageService.areaService?.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-user',
			label: 'Explore Person',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.person.id, toEdit: false } }, 800, 800);
			}
		},
		// {
		// 	iconClass: 'fa-regular fa-message-arrow-up-right',
		// 	label: 'View Engagement',
		// 	isEnabled: rows => (rows.length === 1 && !!rows[0]!.engagementId),
		// 	execute: async rows => {
		// 		if (rows.length == 1) {
		// 			const dialogAction = await dialogService.showDashboardCustom(EngagementViewerDialog, {
		// 				engagementId: rows[0]!.engagementId!,
		// 			}, "xl");
		// 		}
		// 	}
		// },
		// {
		// 	iconClass: 'fa-regular fa-ticket',
		// 	label: 'Create Engagement',
		// 	isEnabled: rows => !!rows.length,
		// 	execute: async rows => {
		// 		const dialogAction = await dialogService.showDashboardCustom(EngagementEditorDialog,
		// 			({
		// 				mode: DialogMode.ADD, engagementId: rows[0]!.engagementId ?? 0,
		// 				staffRoleId: pageService.staffRoleId()!
		// 			}), "lg");
		// 		if (dialogAction?.recordId) {
		// 			await pageService.areaService!.addEngagementIdToContactRequest(rows[0]!.contactRequestId, dialogAction.recordId);
		// 			await pageService.areaService?.reloadData();
		// 		}
		// 	}
		// }
	];

	return actions;
}